import { useState, useEffect } from 'react'
import { Button } from './ui/button'

export function CookieNotice() {
	const [isVisible, setIsVisible] = useState(false)

	useEffect(() => {
		const hasAcceptedCookies = localStorage.getItem('cookies-accepted')
		if (!hasAcceptedCookies) {
			setIsVisible(true)
		}
	}, [])

	const handleAccept = () => {
		localStorage.setItem('cookies-accepted', 'true')
		setIsVisible(false)
	}


	if (!isVisible) return null

	return (
		<div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 lg:left-auto lg:right-6 lg:max-w-md z-50">
			<div className="bg-background border border-border rounded-lg shadow-lg p-4">
				<p className="text-sm text-foreground mb-3">
					We're not using tracking cookies. 
					We only use cookies for essential functionality, like keeping you signed in. 
				</p>
				<Button
					onClick={handleAccept}
					size="sm"
					className="text-xs"
				>
					OK
				</Button>
			</div>
		</div>
	)
}